export default "__VITE_ASSET__BNu$DT3___"